import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { CurrencyService } from './currency.service';
import { LanguageService } from './language.service';

/** Pure rule helpers (exported for unit testing). */
export function isIsraeliMarket(currency: string): boolean {
  return (currency || '').toLowerCase() === 'ils';
}
export function effectiveLanguageFor(currency: string, chosen: string): string {
  return isIsraeliMarket(currency) ? (chosen || 'en') : 'en';
}

@Injectable({ providedIn: 'root' })
export class LocaleService {
  private started = false;

  constructor(
    private currency: CurrencyService,
    private language: LanguageService,
  ) {}

  get israeliMarket(): boolean { return isIsraeliMarket(this.currency.preferred); }

  israeliMarket$: Observable<boolean> =
    this.currency.preferred$.pipe(map(c => isIsraeliMarket(c)));

  /** Selector is only meaningful in the Israeli market (per-route markets override elsewhere). */
  get showLanguageSelector(): boolean { return this.israeliMarket; }

  /** Recompute + apply the effective language whenever currency changes. */
  start(): void {
    if (this.started) { return; }
    this.started = true;
    this.currency.preferred$.subscribe(cur => this.apply(cur));
  }

  /** User picked a language (only reachable while israeliMarket). Persist + re-derive. */
  setChosenLanguage(lang: string): void {
    this.language.setChosenLanguage(lang);
    this.apply(this.currency.preferred);
  }

  private apply(currency: string): void {
    const lang = effectiveLanguageFor(currency, this.language.getChosenLanguage());
    this.language.applyEffective(lang); // sets translate.use + document dir, does NOT persist
  }
}
